/**
 * The one rule the combine dialog cannot afford to get wrong.
 *
 * Combining two accounts cannot be undone: one of them is closed, its email
 * stops signing in on its own, and everything it holds moves to the other. That
 * is why the dialog asks the member to TYPE a word rather than press a second
 * button, and why the word is in capitals.
 *
 * It used to compare with `.toUpperCase()`, so "combine" passed. A confirmation
 * you can satisfy without reading what it asked for is barely a confirmation;
 * the typing is the pause, and the capitals are what make it deliberate.
 *
 * Surrounding space is forgiven, because that is a keyboard slip rather than a
 * failure to read.
 *
 * Pure and exported so it can be tested: this repo has no component-test
 * toolchain, and the rule is too important to live only inside a template.
 */
export const COMBINE_CONFIRMATION = 'COMBINE';

export function combineConfirmationAccepted(typed) {
  return typeof typed === 'string' && typed.trim() === COMBINE_CONFIRMATION;
}
